import TransportTimeLineV1 from './TransportTimeLineV1'
import APIService from '@/api/services/APIService/APIServiceImpl'
import { FullTransportTimeLineResponseDTO, TransportTimeLineResponseDTO } from '../../../../../requests-module'

import axios from 'axios'

export default class TransportTimeLineV1Impl
    extends APIService
    implements TransportTimeLineV1 {
    constructor() {
        const serviceUrl = window.env.VUE_APP_PACKAGE_TIMELINE_URL
        if(!serviceUrl) throw new Error("serviceUrl is mandatory in TransportTimeLineV1Impl")
        super(serviceUrl)
    }
    async getTransportTimeLine(
        prestId: string,
        departureDate: string
    ): Promise<TransportTimeLineResponseDTO> {
        if (!prestId)
            throw new Error('prestId is mandatory in  getTransportTimeLine')
        if (!departureDate)
            throw new Error(
                'departureDate is mandatory in  getTransportTimeLine'
            )
        const { data } = await axios.get(
            `${this.getServiceUrl()}/transport-item/${prestId}/${departureDate}`
        )

        return data
    }
    async getFullTransportTimeLine(
        {
        transportStartDate,
        transportEndDate,
        transferStartDate,
        transferEndDate,
        transportPrestId,
        transferPrestId
        }: {
            transportStartDate: string
            transportEndDate: string
            transferStartDate: string
            transferEndDate: string
            transportPrestId: string
            transferPrestId: string
        }
    ): Promise<FullTransportTimeLineResponseDTO> {
        if (!transportStartDate)
            throw new Error(
                'transportStartDate is mandatory in getTransportAndTransfer'
            )
        if (!transportEndDate)
            throw new Error(
                'transportEndDate is mandatory in getTransportAndTransfer'
            )
        if (!transferStartDate)
            throw new Error(
                'transferStartDate is mandatory in getTransportAndTransfer'
            )
        if (!transferEndDate)
            throw new Error(
                'transferEndDate is mandatory in getTransportAndTransfer'
            )
        if (!transportPrestId)
            throw new Error(
                'transportPrestId is mandatory in getTransportAndTransfer'
            )
        if (!transferPrestId)
            throw new Error(
                'transferPrestId is mandatory in getTransportAndTransfer'
            )

        const { data } = await axios.get(
            `${this.getServiceUrl()}/full-transport-timeline/${transportPrestId}/${transferPrestId}/${transportStartDate}/${transportEndDate}/${transferStartDate}/${transferEndDate}`
        )

        return data
    }
}
